module.exports = __webpack_public_path__ + "static/media/bitmore.c54cd635.svg";